module.exports = __webpack_public_path__ + "static/media/bro-photo.0201a02c.jpg";